var fileTypes = ['pdf', 'docx', 'rtf', 'jpg', 'jpeg', 'png', 'txt'];  //acceptable file types


function readURL(input) {

    if (input.files && input.files[0]) {
        var extension = input.files[0].name.split('.').pop().toLowerCase(),  //file extension from input file
            isSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types

        if (isSuccess) { //yes
            var reader = new FileReader();
            reader.onload = function (e) {
                if (extension == 'pdf') {
                    $(input).closest('.fileUpload').find(".icon").attr('src', 'https://image.flaticon.com/icons/svg/179/179483.svg');
                }
                else if (extension == 'docx') {
                    $(input).closest('.fileUpload').find(".icon").attr('src', 'https://image.flaticon.com/icons/svg/281/281760.svg');
                }
                else if (extension == 'rtf') {
                    $(input).closest('.fileUpload').find(".icon").attr('src', 'https://image.flaticon.com/icons/svg/136/136539.svg');
                }
                else if (extension == 'png') {
                    $(input).closest('.fileUpload').find(".icon").attr('src', 'https://image.flaticon.com/icons/svg/136/136523.svg');
                }
                else if (extension == 'jpg' || extension == 'jpeg') {
                    $(input).closest('.fileUpload').find(".icon").attr('src', 'https://image.flaticon.com/icons/svg/136/136524.svg');
                }
                else if (extension == 'txt') {
                    $(input).closest('.fileUpload').find(".icon").attr('src', 'https://image.flaticon.com/icons/svg/136/136538.svg');
                }
                else {
                    $(input).closest('.uploadDoc').find(".docErr").slideUp('slow');
                }
            }

            reader.readAsDataURL(input.files[0]);
        }
    }
}

$('document').ready(function () {

    if (document.getElementById('candidate')) {

        var briefcaseId=[];
        var file_size=0;

        $('#documents').formValidation({}).on('success.form.fv', function () {
        });
        $('.edit').formValidation({}).on('success.form.fv', function () {
        });

        $(".checkbox").click(function () {
            briefcaseId=[];
            file_size=0;
            var checkarr=$('.btn-box input[type=checkbox]:checked');
            checkarr.each(function (i, val) {
                briefcaseId.push($(val).attr("data-id"));
                file_size+=parseInt($(val).attr("data-file-size"));
            });
            if(file_size<25000000){
                $("#error-block").css("display","none");
            }
        });

        $(".btn-send").click(function (e) {
            var checkarr=$('.btn-box input[type=checkbox]');
            if (checkarr.is(":checked") && file_size<25000000) {
                $('#sendDocs').modal('show');
            };
            if(file_size>25000000){
                $("#error-block").css("display","block");
            }
        });

        $(".btn-finish-send").click(function (e) {
            var data={
                employers_id:$("select.employers").val(),
                files_id:briefcaseId
            };
            $.when(postRequest(data, "Briefcase/send"))
                .done(function (response) {
                        $('#sendDocs').modal('hide');
                    }
                );
        });

        $('.btn-save .btn').bind('click', function (e) {
            e.preventDefault();
            sendData($(this));
        });

        function sendData(id) {
            var id = id.attr("data-id");
            var block = $(".uploadDoc[data-id='" + id + "']");

            if (block.find(".upload.up").val() != '') {
                var fd = new FormData;
                fd.append("file", block.find(".upload.up").prop("files")[0]);
                $.when(postRequestFile(fd, "Briefcase/"+id+"/file"))
                    .done(function (answer) {
                        if(answer!="error"){
                            block.find(".btn-download").attr("href","/"+answer);
                        }
                    });
            }
            var data = {
                note: block.find(".note").val(),
                type: block.find(".type").val()
            };
            putRequest(data, "Briefcase/"+id+"/edit/");
            block.find(".btn-box").removeClass("hidden");
            block.find(".btn-save").addClass("hidden");
            block.find("input:disabled").prop('disabled', true);
            block.find("select:disabled").prop('disabled', true);
        }

        $(".btn-edit").click(function (e) {
            var current = $(this).attr("data-id");
            $(this).parent(".btn-box").addClass("hidden").siblings(".btn-save").removeClass("hidden");
            $(".uploadDoc[data-id='" + current + "']").find("input:disabled").prop('disabled', false);
            $(".uploadDoc[data-id='" + current + "']").find("select:disabled").prop('disabled', false);

        });

        $(document).on('change', '.up', function () {
            var id = $(this).attr('id');
            var profilePicValue = $(this).val();
            var fileNameStart = profilePicValue.lastIndexOf('\\');
            profilePicValue = profilePicValue.substr(fileNameStart + 1).substring(0, 20);
            if (profilePicValue != '') {
                $(this).closest('.fileUpload').find('.upl').html(profilePicValue);
            }
        });
        var fieldNum=0;
        function addNewField() {
            fieldNum++;
            $("#uploader").append('<div class="row uploadDoc new"><div class="col-sm-3"><div class="fileUpload btn btn-orange"> <img src="https://image.flaticon.com/icons/svg/136/136549.svg" class="icon"><span class="upl" id="upload">Upload document</span><input type="file" name="file_'+fieldNum+'" class="upload up"  id="up" onchange="readURL(this);"\n' +
                '                                                               data-buttonName="btn-primary"\n' +
                '                                                               data-input="false"\n' +
                '                                                               data-fv-file="true"\n' +
                '                                                               data-fv-file-extension="doc,docx,pdf,xls,txt,jpeg,jpg,png,eps,tiff,bmp"\n' +
                '                                                               data-fv-file-type="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,text/plain,image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp"\n' +
                '                                                               data-fv-file-maxsize="20971520"\n' +
                '                                                               data-fv-file-message="The file must be in .doc, .docx, .xls, .pdf, .txt, .jpeg, .jpg, .png, .eps, .tiff, .bmp format and must not exceed 20MB in size"/></div></div><div class="col-sm-4">\n' +
                '                                                    <select class="form-control type" placeholder="Type" name="type_'+fieldNum+'">\n' +
                '                                                        <option value="ABN Registration">ABN Registration</option>\n' +
                '                                                        <option value="Business Name Registration">Business Name Registration</option>\n' +
                '                                                        <option value="Certification - ITIL">Certification - ITIL</option>\n' +
                '                                                        <option value="Certification - PMBOK">Certification - PMBOK</option>\n' +
                '                                                        <option value="Cover Letter">Cover Letter</option>\n' +
                '                                                        <option value="CV - Long version">CV - Long version</option>\n' +
                '                                                        <option value="CV - Short version">CV - Short version</option>\n' +
                '                                                        <option value="Employment Contract">Employment Contract</option>\n' +
                '                                                        <option value="ID - Drivers licence scan">ID - Drivers licence scan</option>\n' +
                '                                                        <option value="ID - Passport scan">ID - Passport scan</option>\n' +
                '                                                        <option value="Insurance - PI">Insurance - PI</option>\n' +
                '                                                        <option value="Insurance - PL">Insurance - PL</option>\n' +
                '                                                        <option value="Insurance - WC">Insurance - WC</option>\n' +
                '                                                        <option value="Reference 1">Reference 1</option>\n' +
                '                                                        <option value="Reference 2">Reference 2</option>\n' +
                '                                                        <option value="Reference 3">Reference 3</option>\n' +
                '                                                        <option value="Superannuation Fund">Superannuation Fund</option>\n' +
                '                                                        <option value="Uni Degree - Bachelor">Uni Degree - Bachelor</option>\n' +
                '                                                        <option value="Uni Degree - Masters">Uni Degree - Masters</option>\n' +
                '                                                        <option value="Other">Other</option>\n' +
                '                                                    </select>\n' +
                '                                                </div><div class="col-sm-4"><input type="text" class="form-control" name="note_'+fieldNum+'" placeholder="Note"></div><div class="col-sm-1"><a class="btn-check"><i class="fa fa-times"></i></a></div></div>');

            $('#documents').formValidation('addField', 'file', {
                validators: {
                    file: {
                        extension: 'doc,docx,pdf,xls,txt,jpeg,jpg,png,eps,tiff,bmp',
                        type: "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,text/plain,image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp",
                        maxSize: 20 * 1024 * 1024,
                        message: 'The file must be in .doc, .docx, .xls, .pdf, .txt, .jpeg, .jpg, .png, .eps, .tiff, .bmp format and must not exceed 20MB in size'
                    }
                }
            });
        }

        $(".btn-new").on('click', addNewField);

        $(document).on("click", "a.btn-check", function () {
            if ($(".uploadDoc").length > 1) {
                $(this).closest(".uploadDoc").remove();
            }
            var id = $(this).attr('data-id');
            var data = {id:id};
            deleteRequest(data,"/Briefcase/"+id+"/delete");
        });


        // ================================================================================================================================

        $('.for_about_us').on('click', function () {
            $("#empl_about_us #text").html($(this).attr("data-about"));
            $("#empl_about_us .company_name").html($(this).attr("data-company_name"));
            $("#empl_about_us .company_site").html($(this).attr("data-company_site")).attr("href", $(this).attr("data-company_site"));
            $("#empl_about_us").modal("show");
        });

        $("#empl_about_us").on('hidden.bs.modal', function () {
            $("#empl_about_us #text").html($(this).attr("data-about"));
            $("#empl_about_us .company_name").html("");
            $("#empl_about_us .company_site").html("");
        });

        function cleanResults() {
            $(".onchange").change(function () {
                $(".candidates_project").html("");
            });
        }

        $('#sort_switcher').change(function () {
            $('.sort-box').hide();
            var sortType = $(this).val();
            if (sortType) {
                $('#' + sortType).show();
            }
        });

        var counter = 0;
        if ($("#profile").hasClass("my_project_page")) {
            $(".sorting_box").click(function (e) {
                e.preventDefault();
                $(".sorting_box").find("span").show();
                $(this).find("span").css("display", "none");
                var sort_options = $(this).attr("data-sort");
                if (counter) {
                    var data = {
                        count: "all",
                        isMy: "true",
                        from_cache: "true"
                    }
                } else {
                    var data = {
                        count: "all",
                        isMy: "true"
                    }
                    counter++
                }


                var sort = $(this).attr("data-sort-field");
                if (sort == "start_date") {
                    data.sort_field = "start_date";
                    sort_field = "start_date";
                }
                if (sort == "employer_name") {
                    data.sort_field = "employer_name";
                    sort_field = "employer_name";
                }
                if (sort == "project_name") {
                    data.sort_field = "project_name";
                    sort_field = "project_name";
                }

                if (sort_options == "no") {
                    $(this).attr("data-sort", "low-high");
                    $(this).find("span.low-high").show();
                    data.sort_type = "asc";
                    sort_type = "asc";

                } else if (sort_options == "low-high") {
                    $(this).attr("data-sort", "high-low");
                    $(this).find("span.high-low").show();
                    data.sort_type = "desc";
                    sort_type = "desc";
                } else {
                    $(this).attr("data-sort", "no");
                    $(this).find("span.high-low").show();
                    $(this).find("span.low-high").show();
                    data.sort_type = "empty";
                    sort_type = "empty";
                }


                $.when(postRequest(data, "/people/filter"))
                    .done(function (answer) {
                            var newData = answer.data;

                            if (newData["closed"].length) {
                                renderProject(newData["closed"], $("#closed-projects .candidates_project"));
                            } else {
                                $("#closed-projects .candidates_project .person .h4").html("No closed projects yet.")
                            }
                            if (newData["open"].length) {
                                renderProject(newData["open"], $("#active-projects .candidates_project"));
                            } else {
                                $("#active-projects .candidates_project .person .h4").html("No applications yet, launch a new search and see what's out there.")
                            }

                        }
                    );
            })
        }


        // =============================filters=======================
        if ($("#profile").hasClass("search_page")) {

            $(".search-box .first-inp").select2({
                placeholder: 'SAP Module'
            });

            $(".search-box .second-inp").select2({
                placeholder: 'SAP skills',
                allowClear: true
            });

            $(".search-box .cities").select2({
                placeholder: 'City',
                allowClear: true
            });


            $(".search-box .search-type").select2({
                minimumResultsForSearch: -1
            });

            $(".search-box .date-opened").select2({
                minimumResultsForSearch: -1
            });


            var skills_edit = $(".second-inp").val();

            function eventOnSearchBySkills(data, tab) {
                var options1 = [];
                var options2 = {};
                data.sort(function (a, b) {
                    return b["name"] < a["name"] ? 1 : -1;
                });
                data.forEach(function (item, i) {
                    var option1;
                    option1 = new Option(item['name'], item['id']);
                    options2[item['id']] = [];

                    item["parameters"].forEach(function (item2, j) {
                        var option2 = [];
                        if (item2["name"] != "Other") {
                            option2 = new Option(item2['name'], item2['id']);
                            options2[item['id']].push(option2);
                        }
                    })
                    options1.push(option1);
                });
                options1.sort(function (a, b) {
                    return b["label"] < a["label"] ? 1 : -1;
                });
                $(tab + " .first-inp").append(options1);


                // ==================if edit=========
                var sap_skills_edit = $("#sap_skills").val();
                var options = [];
                if (sap_skills_edit) {
                    sap_skills_edit.forEach(function (item, i) {
                        options = options.concat(options2[item]);
                    });
                }

                options.sort(function (a, b) {
                    return b["label"] < a["label"] ? 1 : -1;
                });
                $(tab + " .second-inp").html("").append(options);
                $('#sap_skills_2').val(skills_edit).trigger('change');
                // ===========================


                $(tab + "  .first-inp").on("change", function () {
                    var firstVal = $(this).val();
                    var options = [];
                    if (firstVal) {
                        firstVal.forEach(function (item, i) {

                            options = options.concat(options2[item]);
                        });
                    }
                    options.sort(function (a, b) {
                        return b["label"] < a["label"] ? 1 : -1;
                    });
                    $(tab + " .second-inp").html("").append(options);
                });
                cleanResults();
            }


            // =============================sorting=======================
            // var search_data = JSON.parse(fist_data.replace(/&quot;/g, '"').replace(/\\/g, "/"));
            // var data_for_sorting = [];
            //
            // if (search_data.length) {
            //     for (c = 0; c < search_data.length; c++) {
            //         if (search_data[c]['project_status'] != "closed") {
            //             data_for_sorting.push(search_data[c]);
            //         }
            //     }
            // }
            // renderProject(data_for_sorting);
            // addPaginator(data_for_sorting.length, $(".pagination"));
            // var last_data=[];
            // last_data = $.map(data_for_sorting, function (obj) {
            //     return $.extend(true, {}, obj);
            // });

            var sort_field = "empty";
            var sort_type = "empty";
            var globaloffset = 0;
            var globalcount = 10;

            $(".sorting_box").click(function (e) {
                e.preventDefault();
                $(".sorting_box").find("span").show();
                $(this).find("span").css("display", "none");
                var sort_options = $(this).attr("data-sort");

                var data = {
                    from_cache: "on",
                    count: globalcount,
                    offset: globaloffset
                }

                var sort = $(this).attr("data-sort-field");
                if (sort == "start_date") {
                    data.sort_field = "start_date";
                    sort_field = "start_date";
                }
                if (sort == "employer_name") {
                    data.sort_field = "employer_name";
                    sort_field = "employer_name";
                }
                if (sort == "project_name") {
                    data.sort_field = "project_name";
                    sort_field = "project_name";
                }

                if (sort_options == "no") {
                    $(this).attr("data-sort", "low-high");
                    $(this).find("span.low-high").show();
                    data.sort_type = "asc";
                    sort_type = "asc";

                } else if (sort_options == "low-high") {
                    $(this).attr("data-sort", "high-low");
                    $(this).find("span.high-low").show();
                    data.sort_type = "desc";
                    sort_type = "desc";
                } else {
                    $(this).attr("data-sort", "no");
                    $(this).find("span.high-low").show();
                    $(this).find("span.low-high").show();
                    data.sort_type = "empty";
                    sort_type = "empty";
                }


                $.when(postRequest(data, "/people/filter"))
                    .done(function (answer) {
                            var newData = answer.data;
                            if (newData.length) {

                                renderProject(newData, $(".candidates_project"));

                                $('html, body').animate({
                                    scrollTop: $(".results_box").offset().top
                                }, 2000);

                            } else {
                                $(".candidates_project").html("<h4>No projects match that - relax your search a little and try again.</h4>")
                            }
                        }
                    );
            })

// ==================================================


            var category = {data: ["SAP"]};

            $.when(postRequest(category, "/api/user/notification"))
                .done(function (answer) {
                        var data = answer[0]['category_type'];
                        eventOnSearchBySkills(data, ".search-box");
                    }
                );


            $.when(postRequest(category, "/api/get/skills/all"))
                .done(function (answer) {
                        var data = answer[0]['category_type'];
                        eventOnSearchBySkills(data, ".search-box");
                    }
                );
            $("#search-projects").click(function (e) {
                $(".sorting_box").find("span").show();
                sort_field = "empty";
                sort_type = "empty";
                var data = $("form.search-box").serializeArray();

                if ($("#sort_switcher").val() == "Price") {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i]["name"] == "date-opened") {
                            delete data[i];
                        }
                    }
                } else {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i]["name"] == "rate-type" || data[i]["name"] == "price") {
                            delete data[i];
                        }
                    }
                }

                var dataF = data.filter(function (el) {
                    return el != null;
                });

                $.when(postRequest(dataF, "/people/filter"))
                    .done(function (answer) {
                            var newData = answer.data;
                            var openPr = [];
                            if (newData.length) {
                                for (c = 0; c < newData.length; c++) {
                                    if (newData[c]['project_status'] != "closed") {
                                        openPr.push(newData[c]);
                                    }
                                }
                            }
                            if (openPr.length) {
                                renderProject(openPr, $(".candidates_project"));
                            } else {
                                $(".candidates_project").html("<h4>No projects match that - relax your search a little and try again.</h4>");
                            }
                            addPaginator(answer.global_count, $(".pagination"));
                        }
                    );
            });
        }

        // =============================================================


        function unapplyCand(answer, self, target, action) {
            self.find(".apply img").attr('disabled', false);
            self.find(".apply img").attr("src", "/img/icons_svg/ico-applied-yellow.svg");
            self.find(".apply span").html("Apply");
            if (+target.parents("." + action["name"]).size()) {
                target.parent("." + action["name"]).addClass("yes_cursor").removeClass("no_cursor");

            } else {
                target.addClass("yes_cursor").removeClass("no_cursor");
            }
            self.find(".unapply").addClass("unapply-0");
        };

        function applyCand(answer, self, target, action) {
            self.find(".apply img").attr('disabled', 'disabled');
            self.find(".apply img").attr("src", "/img/icons_svg/ico-applied-yes.svg");
            self.find(".apply span").html("Applied");
            if (+target.parents("." + action["name"]).size()) {
                target.parent("." + action["name"]).addClass("no_cursor");

            } else {
                target.addClass("no_cursor")
            }
            self.find(".unapply").removeClass("unapply-0");
        };

        function addEvent() {
            $('.item-project').on('hide.bs.collapse', function () {
                $(this).find(".full-details").html("...");
                $(this).find(".cut-description").removeClass("hidden");
                $(this).find(".cut-allDescription").addClass("hidden");
            }).on("show.bs.collapse", function () {
                $(this).find(".full-details").html("Hide");
                $(this).find(".cut-description").addClass("hidden");
                $(this).find(".cut-allDescription").removeClass("hidden");

            });
            $('.for_about_us').on('click', function () {
                $("#empl_about_us #text").html($(this).attr("data-about"));
                $("#empl_about_us .company_name").html($(this).attr("data-company_name"));
                $("#empl_about_us .company_site").html($(this).attr("data-company_site")).attr("href", $(this).attr("data-company_site"));
                $("#empl_about_us").modal("show");
            });

            $("#empl_about_us").on('hidden.bs.modal', function () {
                $("#empl_about_us #text").html($(this).attr("data-about"));
                $("#empl_about_us .company_name").html("");
                $("#empl_about_us .company_site").html("");
            });
        }

        addEvent();

        function addEventForCand(tag) {
            tag.click(function (e) {
                var self = $(this);
                var target = $(e.target);
                var action;
                var classes = target.attr("class") + "";
                classes += target.parent().attr("class");

                var candActions = [
                    {
                        name: "apply",
                        feedback: applyCand,
                        route: "/api/project/apply"
                    },
                    {
                        name: "unapply",
                        feedback: unapplyCand,
                        route: "/api/project/unapply"
                    }
                ];

                for (i = 0; i < candActions.length; i++) {
                    if (classes.indexOf(candActions[i]['name']) >= 0) {
                        action = candActions[i];
                    }
                }

                if (target.parents("." + action["name"]).size() || target.hasClass("." + action["name"])) {
                    var data;
                    if (+target.parents("." + action["name"]).size()) {
                        data = {
                            project_id: target.parent("." + action["name"]).attr("data-id"),
                        };

                    } else {
                        data = {
                            project_id: target.attr("data-id"),
                        };
                    }

                    $.when(postRequest(data, action["route"]))
                        .done(function (answer) {

                                if (answer) {
                                    action["feedback"](answer, self, target, action);
                                }

                            }
                        );


                }

            })
        }

        addEventForCand($("#profile.candidate .column-status"));

        $(".askBox").click(function (e) {
            var self = $(this);
            if (self.hasClass("hire-info")) {

                var target = $(e.target);
                var data = {};
                var status, text;

                data.project_id = target.attr("data-id");
                data.answer = false;

                if (target.hasClass("disagree")) {
                    data.answer = "no";
                    status = 0;
                    text = "Not Progressing"
                }

                if (target.hasClass("agree")) {
                    data.answer = "yes";
                    status = 2;
                    text = "Under Offer"
                }
                if (data.answer) {

                    $.when(postRequest(data, "/api/project/hire/answer"))
                        .done(function (answer) {
                            if (answer) {
                                if (data.answer == "yes") {
                                    $("#tree-" + data.project_id).find("img").attr("src", "/img/icons_svg/ico-closed-yes.svg");
                                    $("#tree-" + data.project_id).find(".descr").html("Tree Allocated");
                                }
                                $("#engaged-" + data.project_id).find("img").attr("src", "/img/icons_svg/ico-engaged-" + status + ".svg");
                                $("#engaged-" + data.project_id).find(".descr").html(text);
                                self.removeClass("hire-info").addClass("not-hire");
                            }
                        })
                }
            }
        });

        // ====================================
        function addFirstPaginator(objPaginator) {

            var numItems = $(".item-project").length;
            var perPage = 10;
            var displayedPages = 3;

            $(".candidates_project .item-project").slice(perPage).hide();
            // objPaginator.pagination({
            //     items: numItems,
            //     itemsOnPage: perPage,
            //     hrefTextPrefix: '#' + name + 'page-',
            //     displayedPages: displayedPages,
            //
            //     onPageClick: function (pageNumber) {
            //         var showFrom = perPage * (pageNumber - 1);
            //         var showTo = showFrom + perPage;
            //         $(".item-project").hide().slice(showFrom, showTo).show();
            //
            //         $('html, body').animate({
            //             scrollTop: $(".results_box").offset().top
            //         }, 2000);
            //     }
            // });
            objPaginator.pagination({
                items: numItems,
                itemsOnPage: perPage,
                hrefTextPrefix: '#' + name + 'page-',
                displayedPages: displayedPages,

                onPageClick: function (pageNumber) {
                    var pr_id = $("#search-people").attr("data-pr-id");
                    var offset = perPage * (pageNumber - 1);
                    globaloffset = offset;
                    var count;
                    if (pageNumber * perPage > numItems) {
                        count = numItems % perPage;
                    } else {
                        count = perPage;
                    }
                    globalcount = count;
                    var data = {
                        from_cache: "on",
                        count: count,
                        offset: offset,
                        sort_field: sort_field,
                        sort_type: sort_type
                    }
                    $.when(postRequest(data, "/people/filter"))
                        .done(function (answer) {
                                var newData = answer.data;
                                if (newData.length) {
                                    // rendersPeopleForSearch(newData, pr_id);

                                    renderProject(newData, $(".candidates_project"));

                                    $('html, body').animate({
                                        scrollTop: $(".results_box").offset().top
                                    }, 2000);

                                } else {
                                    $(".candidates_project").html("<h4>No projects match that - relax your search a little and try again.</h4>")
                                }
                            }
                        );
                }
            });
            checkFragment(objPaginator, name);
        }

        addFirstPaginator($(".pagination"));

        function checkFragment(ob, name) {

            var hash = window.location.hash || name + "page-1";
            hash = hash.match(/^#cand-page-(\d+)$/);
            if (hash) {
                ob.pagination("selectPage", parseInt(hash[1]));
            }
        }

        $(window).bind("popstate", checkFragment);

        function addPaginator(global_count, objPaginator) {

            var numItems = global_count;
            var perPage = 10;
            var displayedPages;
            if (numItems <= perPage) {
                displayedPages = 1;
            } else {
                displayedPages = 3;
            }

            objPaginator.pagination({
                items: numItems,
                itemsOnPage: perPage,
                hrefTextPrefix: '#' + name + 'page-',
                displayedPages: displayedPages,

                onPageClick: function (pageNumber) {
                    var pr_id = $("#search-people").attr("data-pr-id");
                    var offset = perPage * (pageNumber - 1);
                    var count;
                    if (pageNumber * perPage > numItems) {
                        count = numItems % perPage;
                    } else {
                        count = perPage;
                    }
                    var data = {
                        from_cache: "on",
                        count: count,
                        offset: offset,
                        sort_field: sort_field,
                        sort_type: sort_type
                    }
                    $.when(postRequest(data, "/people/filter"))
                        .done(function (answer) {
                                var newData = answer.data;
                                if (newData.length) {
                                    // rendersPeopleForSearch(newData, pr_id);

                                    renderProject(newData, $(".candidates_project"));

                                    $('html, body').animate({
                                        scrollTop: $(".results_box").offset().top
                                    }, 2000);

                                } else {
                                    $(".candidates_project").html("<h4>No projects match that - relax your search a little and try again.</h4>")
                                }
                            }
                        );
                }
            });

            checkFragment(objPaginator, name);
        }

        function compare(a, b) {
            var aDate = new Date(a['data']);
            var bDate = new Date(b['data']);
            if (aDate < bDate)
                return -1;
            if (aDate > bDate)
                return 1;
            return 0;
        }

        // =============================render===========================================


        function renderProject(arrData, tab) {

            if (arrData.length) {


                var data = [];

                var noData = "not_indicated";

                for (var i = arrData.length - 1; i >= 0; i--) {
                    var tick, tickStatus, unapply, sapSkills;
                    var num = Math.floor(Math.random() * (1000 - 1)) + 1;
                    var dates = arrData[i].dates[0];
                    var dateLength = dates.Data.length;
                    var lastDate, firstDate = 0, duration, startDate, tmp = 1;

                    dates['Data'].sort(compare);

                    if (dateLength) {
                        lastDate = dates.Data[dateLength - 1].data;

                        jQuery.each(dates.Data, function (i, val) {
                            if (val["status"] == "green" && tmp) {
                                firstDate = val["data"];
                                tmp = 0;
                            }
                        });

                        if (arrData[i].other_skills.hasOwnProperty('Delivery Basis')) {
                            if (arrData[i].other_skills['Delivery Basis'].hasOwnProperty('Permanent') && typeof  arrData[i]['other_skills']['Delivery Basis']["Contract"] == "undefined") {
                                duration = 'permanent'
                                startDate = "not_indicated"
                                // startDate = "Date is not specified"
                            } else {
                                var tmp = moment.duration(moment(lastDate).diff(moment(firstDate)));
                                var y = "";
                                var m = "";
                                var d = "";
                                if (tmp.years() == 1) {
                                    y = tmp.years() + " year ";
                                } else if (tmp.years() > 1) {
                                    y = tmp.years() + " years ";
                                }

                                if (tmp.months() == 1) {
                                    m = tmp.months() + " month ";
                                } else if (tmp.months() > 1) {
                                    m = tmp.months() + " months ";
                                }

                                if (tmp.days() == 1) {
                                    d = tmp.days() + " day";
                                } else if (tmp.days() > 1) {
                                    d = tmp.days() + " days";
                                }


                                duration = y + m + d;

                                if (firstDate) {
                                    startDate = moment(firstDate).format('MMM DD, YYYY');
                                } else {
                                    startDate = "not_indicated"
                                }
                            }
                        } else {

                            var tmp = moment.duration(moment(lastDate).diff(moment(firstDate)));
                            var y = "";
                            var m = "";
                            var d = "";
                            if (tmp.years() == 1) {
                                y = tmp.years() + " year ";
                            } else if (tmp.years() > 1) {
                                y = tmp.years() + " years ";
                            }

                            if (tmp.months() == 1) {
                                m = tmp.months() + " month ";
                            } else if (tmp.months() > 1) {
                                m = tmp.months() + " months ";
                            }

                            if (tmp.days() == 1) {
                                d = tmp.days() + " day";
                            } else if (tmp.days() > 1) {
                                d = tmp.days() + " days";
                            }

                            duration = y + m + d;
                            if (firstDate) {
                                startDate = moment(firstDate).format('MMM DD, YYYY');
                            } else {
                                startDate = "not_indicated"
                            }
                        }

                    } else {
                        if (arrData[i].other_skills.hasOwnProperty('Delivery Basis')) {
                            if (arrData[i].other_skills['Delivery Basis'].hasOwnProperty('Permanent') && typeof  arrData[i]['other_skills']['Delivery Basis']["Contract"] == "undefined") {
                                duration = 'permanent';
                            }
                        } else {
                            duration = "Date is not specified";
                        }
                        startDate = "not_indicated";
                    }
                    if (arrData[i].user_project) {

                        if (arrData[i].user_project.applied != "0") {

                            tick = "yes";
                            tickStatus = "Applied";
                            unapply = 1;
                        } else {
                            tick = "yellow";
                            tickStatus = "Apply";
                            unapply = 0;
                        }
                    } else {
                        tick = "yellow";
                        tickStatus = "Applied";
                        unapply = 0;
                    }
                    if (arrData[i].user_project.unapplied) {
                        tick = "not";
                        tickStatus = "Application Withdrawn";
                    }

                    var industry = [];
                    var deliveryBasis = [];
                    var travelRequired = [];
                    var securityClearanceRequired = [];
                    var methodology = [];
                    var certification = [];
                    var leafStatus, leaf, tree, treeStatus;


                    for (var key in arrData[i].other_skills) {

                        if (key == "Industry") {
                            for (var key2 in arrData[i].other_skills[key]) {
                                industry.push(key2);
                            }
                        }

                        if (key == "Delivery Basis") {
                            for (var key2 in arrData[i].other_skills[key]) {
                                deliveryBasis.push(key2);
                            }
                        }

                        if (key == "Travel Required") {
                            for (var key2 in arrData[i].other_skills[key]) {
                                travelRequired.push(key2);
                            }
                        }

                        if (key == "Security Clearance") {
                            for (var key2 in arrData[i].other_skills[key]) {
                                securityClearanceRequired.push(key2);
                            }
                        }

                        if (key == "Methodology") {
                            for (var key2 in arrData[i].other_skills[key]) {
                                methodology.push(key2);
                            }
                        }

                        if (key == "Methodology") {
                            for (var key2 in arrData[i].other_skills[key]) {
                                methodology.push(key2);
                            }
                        }

                        if (key == "Certification Required") {
                            for (var key2 in arrData[i].other_skills[key]) {
                                certification.push(key2);
                            }
                        }
                    }
                    var inContact, handshake, handshakeStatus, list, listStatus, eye, eyeStatus, status, rating, hire,
                        cancelBtn;
                    var isFinishedPr = "open";

                    if (arrData[i].job.status.name == "closed") {
                        isFinishedPr = "closedProject"
                    }

                    if (arrData[i].job.status.name != "closed") {
                        leafStatus = "Project Opened";
                        leaf = "opened";
                        tree = "not";
                        treeStatus = "Tree Reserved";
                    } else {
                        leafStatus = "Project closed";
                        leaf = "closed";
                        tree = "yes"
                        treeStatus = "Tree Allocated";
                    }

                    if (arrData[i].user_project) {
                        inContact = arrData[i].user_project.in_contact;
                        list = arrData[i].user_project.shortlisted ? 1 : 0;
                        listStatus = arrData[i].user_project.shortlisted ? "Shortlisted" : "Shortlist Pending";
                        eye = (arrData[i].user_project.is_view && arrData[i].user_project.is_view != '0') ? "yes" : "not";
                        eyeStatus = (arrData[i].user_project.is_view && arrData[i].user_project.is_view != '0') ? "Profile Viewed" : "Assessment Pending";
                        status = arrData[i].user_project.status;
                        inContact = 0;
                        handshake = 1;
                        handshakeStatus = "Outcome pending";
                        list = 0;
                        listStatus = "Shortlist Pending";
                        eye = "not";
                        eyeStatus = "Assessment Pending";
                        status = "not"
                    }
                    if (isFinishedPr == "closedProject") {
                        cancelBtn = 0;
                    } else {
                        cancelBtn = handshake;
                    }

                    Array.prototype.removeDuplicate = function () {
                        var result = [];
                        for (var i = 0; i < this.length; i++) {
                            if (result.indexOf(this[i]) == -1) result.push(this[i]);
                        }
                        return result;
                    }
                    var str = arrData[i].sap_skills.join(", ");
                    sapSkills = str.split(",").removeDuplicate().join(", ");


                    var budgetMax, budgetMin;
                    budgetMax = "not_indicated";
                    budgetMin = "not_indicated";
                    if (arrData[i].job.display_rates == 1 || arrData[i].job.display_rates == true) {
                        budgetMax = arrData[i].job.display_rates ? arrData[i].job.budget_range_max : "not_indicated";
                        budgetMin = arrData[i].job.display_rates ? arrData[i].job.budget_range_min : "not_indicated";
                        if (typeof  arrData[i]['other_skills']['Delivery Basis'] !== "undefined") {

                            if (typeof  arrData[i]['other_skills']['Delivery Basis']["Contract"] !== "undefined") {
                                budgetMin = "not_indicated";
                            } else if (typeof  arrData[i]['other_skills']['Delivery Basis']["Permanent"] !== "undefined") {
                                budgetMax = "not_indicated";
                            }

                            if (typeof  arrData[i]['other_skills']['Delivery Basis']["Contract"] !== "undefined" && typeof  arrData[i]['other_skills']['Delivery Basis']["Permanent"] !== "undefined") {
                                budgetMax = arrData[i].job.display_rates ? arrData[i].job.budget_range_max : "not_indicated";
                                budgetMin = arrData[i].job.display_rates ? arrData[i].job.budget_range_min : "not_indicated";
                            }
                        }
                    }
                    var consulting_skills;

                    data[i] = {

                        name: arrData[i].employer.user.first_name + " " + arrData[i].employer.user.last_name,
                        summary: arrData[i].employer.about_us,
                        summaryView: arrData[i].employer.about_us !== "" ? "" : noData,
                        website: arrData[i].employer.website,
                        websiteView: arrData[i].employer.website !== "" ? "" : noData,
                        twitter: arrData[i].employer.user.twitter,
                        twitterView: arrData[i].employer.user.twitter !== "" ? "" : noData,

                        uniqueId: arrData[i].job.id + num,

                        idProject: arrData[i].job.id,
                        createDate: moment(arrData[i].job.created_at).format('MMM DD, YYYY'),
                        logo: "/" + arrData[i].employer_img,
                        description: arrData[i].job.position_description !== "" ? arrData[i].job.position_description.slice(0, 200) : noData,
                        allDescription: arrData[i].job.position_description !== "" ? arrData[i].job.position_description : noData,
                        companyName: arrData[i].employer.company_name !== "" ? arrData[i].employer.company_name : noData,
                        sapSkills: sapSkills,
                        consulting_skills: arrData[i].consulting_skills.length ? arrData[i].consulting_skills.join(', ') : noData,
                        industry_solution: noData,
                        industry_solution_class: noData,
                        skills: arrData[i].required_skills.join(', '),
                        startDate: startDate,
                        duration: duration,
                        scope: arrData[i].job.project_scope !== "" ? arrData[i].job.project_scope : noData,
                        budgetMin: budgetMin,
                        budgetMax: budgetMax,
                        position: arrData[i].employer.position !== "" ? arrData[i].employer.position : noData,
                        industry: industry.length ? industry.join(', ') : noData,
                        deliveryBasis: deliveryBasis.length ? deliveryBasis.join(', ') : noData,
                        suburb: arrData[i].job.suburb !== "" ? arrData[i].job.suburb : noData,
                        town: arrData[i].job.town !== "" ? arrData[i].job.town : noData,
                        state: arrData[i].job.state !== "" ? arrData[i].job.state : noData,
                        postCode: arrData[i].job.post_code !== "" ? arrData[i].job.post_code : noData,
                        country: arrData[i].other_skills.Country !== "" ? arrData[i].other_skills.Country : noData,
                        travelRequired: travelRequired.length ? travelRequired.join(', ') : noData,
                        possibleExtension: arrData[i].job.possible_extension !== "" ? arrData[i].job.possible_extension : noData,
                        securityClearanceRequired: securityClearanceRequired.length ? securityClearanceRequired.join(', ') : noData,
                        minVisaRequired: arrData[i].job.min_visa_required !== "" ? arrData[i].job.min_visa_required : noData,
                        sponsorship: arrData[i].job.sponsorship_available !== "" ? arrData[i].job.sponsorship_available : noData,
                        certification: certification.length ? certification.join(', ') : noData,
                        methodology: methodology.length ? methodology.join(', ') : noData,
                        positionDescription: arrData[i].job.document_path !== "" ? "/" + arrData[i].job.document_path : ".disabled",
                        positionDescriptionView: arrData[i].job.document_path == "" ? "not_indicated" : "",
                        calendarData: JSON.stringify(arrData[i].dates),
                        eye: eye,
                        eyeStatus: eyeStatus,
                        tick: tick,
                        tickStatus: tickStatus,
                        list: list,
                        listStatus: listStatus,
                        inContact: inContact,
                        handshake: handshake,
                        handshakeStatus: handshakeStatus,
                        status: status,
                        isFinishedPr: isFinishedPr,
                        cancelBtn: cancelBtn,
                        unapply: unapply,
                        leafStatus: leafStatus,
                        leaf: leaf,
                        tree: tree,
                        treeStatus: treeStatus
                    };
                }


                var info = transformData(data);

                $.when(renderMustache(info, tab, "/templates/profile/project.html", tab, '#project')).done(function (answer) {
                        if (answer) {
                            init();
                            addEventOnCalendar();
                            addEventForCand($("#profile.candidate .column-status"));
                            addEvent();

                        }
                    }
                );

            }
        }

        //========================for mustache ==================
        function renderMustache(info, conLoad, file, contOnPage, id) {
            var deferred = $.Deferred();
            conLoad.load(file + id + '', function () {
                var template = $(id).html();
                var substr = "data-src";
                template = template.replace(new RegExp(substr, 'g'), "src");
                var output = Mustache.render(template, info);
                contOnPage.html(output);
                deferred.resolve(true);
            });
            return deferred.promise();
        }

        function transformData(data) {

            return {
                data: data.map(function (data) {
                    return data
                })
            }
        }


        //=================request============================

        function postRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST'
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }

        function putRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'PUT'
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }
        function deleteRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'DELETE',
                    contentType:'application/json'
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }
        function postRequestFile(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                    contentType: false,
                cache: false,
                    processData: false
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }
    }
});